import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {composeWithDevTools} from 'redux-devtools-extension';
import {applyMiddleware, createStore} from 'redux';
import {Provider} from 'react-redux';
import thunk from 'redux-thunk';
import About from "./screens/about"
import Login from "./screens/access/login"
import Register from "./screens/access/registry"
import RequestPassword from "./screens/access/requestpassword"
import ResetPassword from "./screens/access/resetpassword"
import UserInfo from "./screens/access/userinfo"
import Contact from "./screens/contact"
import Gallery from "./screens/gallery"
import GalleryViewer from "./screens/gallery_viewer"
import NewDetail from "./screens/newDetail"
import MyProjects from "./screens/projects";
import News from "./screens/news";
import Home from "./screens/home";
import NewHome from "./screens/newhome/home";
import Tools from "./screens/tools";
import ExpensesSplit from './screens/expensesSplit';
import MyServices from './screens/services';

import rootReducer from './reducers';


const middlewareList = [thunk];
const enhancer = composeWithDevTools(
    applyMiddleware(...middlewareList)
);

const store = createStore(rootReducer, enhancer);

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter>
            <main>
                <Switch>
                    <Route path='/expensesSplit' component={ExpensesSplit}/>
                    <Route path='/about' component={About}/>
                    <Route path='/login' component={Login}/>
                    <Route path='/register' component={Register}/>
                    <Route path='/requestPasswordReset' component={RequestPassword}/>
                    <Route path='/resetPassword' component={ResetPassword}/>
                    <Route path="/projects" component={MyProjects}/>
                    <Route path="/news" component={News}/>
                    <Route path='/news/:id' component={NewDetail}/>
                    <Route path='/about' component={About}/>
                    <Route path='/old_home' component={Home}/>
                    <Route path='/tools' component={Tools}/>
                    <Route path='/contact' component={Contact}/>
                    <Route path='/gallery' component={Gallery}/>
                    <Route path='/gallery_viewer' component={GalleryViewer}/>
                    <Route path='/user_info' component={UserInfo}/>
                    <Route path='/my_services' component={MyServices}/>
                    <Route path='/' component={NewHome}/>
                </Switch>
            </main>
        </BrowserRouter>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js